var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorFood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.471,
    height: 20.471,
    viewBox: "0 0 20.471 20.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8435",
    "data-name": "Group 8435",
    opacity: 0.696
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1549",
    "data-name": "Rectangle 1549",
    width: 20.471,
    height: 20.471,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8445",
    "data-name": "Group 8445",
    transform: "translate(3.794 0.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7277",
    "data-name": "Path 7277",
    d: "M390.516,255.5a3.073,3.073,0,0,0-6.13,0,4.591,4.591,0,0,0,1.384,4.514c.921,1.051,1.092.725,1.04,1.98s-.377,7.486-.413,8.538-.281,2.494,1.055,2.494,1.09-1.443,1.055-2.494-.361-7.284-.413-8.538.119-.929,1.04-1.98A4.591,4.591,0,0,0,390.516,255.5Z",
    transform: "translate(-384.258 -252.646)",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7278",
    "data-name": "Path 7278",
    d: "M436.62,258.455c.407-1.023-.278-5.413-.278-5.413-.06-.405-.25-.423-.408-.381s-.145.426-.134.74a22.892,22.892,0,0,1,.1,3.48.548.548,0,0,1-.235.361s-.354-.124-.389-1.2-.057-2.708-.058-2.962a.367.367,0,0,0-.254-.4c-.108-.017-.29.117-.292.4s.087,3.5,0,3.752a.332.332,0,1,1-.564,0c-.087-.251,0-3.47,0-3.752s-.184-.417-.292-.4a.367.367,0,0,0-.254.4c0,.254-.023,1.876-.058,2.962s-.384,1.2-.389,1.2a.548.548,0,0,1-.235-.361,22.908,22.908,0,0,1,.1-3.48c.011-.314.024-.7-.134-.74s-.348-.024-.408.381c0,0-.685,4.39-.278,5.413s1.4,1.743,1.488,2.568a3.16,3.16,0,0,1,.1.972c-.052,1.255-.377,7.486-.413,8.538s-.281,2.494,1.055,2.494,1.09-1.443,1.054-2.494-.361-7.284-.413-8.538a3.95,3.95,0,0,1,.1-.972C435.223,260.2,436.213,259.479,436.62,258.455Z",
    transform: "translate(-423.866 -252.646)",
    fill: "#5475c2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorFood);
export default __webpack_public_path__ + "static/media/color_food.a1c7b9483041282f09833dc8c3a395d5.svg";
export { ForwardRef as ReactComponent };